/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Objednejte rychleji`
};

const da_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Hurtigere betaling`
};

const de_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Schnellerer Checkout`
};

const en_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Faster checkout`
};

const es_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Compra más rápido`
};

const fr_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Commandez plus rapidement`
};

const hu_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Gyorsabban fizet ki`
};

const it_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Ordina più velocemente`
};

const nl_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Sneller afrekenen`
};

const pl_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Szybsze zakupy`
};

const pt_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Compre mais rápido`
};

const sv_account_register_benefits_faster_checkout = /** @type {(inputs: {}) => string} */ () => {
	return `Snabbare utcheckning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_benefits_faster_checkout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_benefits_faster_checkout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_benefits_faster_checkout", locale)
	if (locale === "cs") return cs_account_register_benefits_faster_checkout(inputs)
	if (locale === "da") return da_account_register_benefits_faster_checkout(inputs)
	if (locale === "de") return de_account_register_benefits_faster_checkout(inputs)
	if (locale === "en") return en_account_register_benefits_faster_checkout(inputs)
	if (locale === "es") return es_account_register_benefits_faster_checkout(inputs)
	if (locale === "fr") return fr_account_register_benefits_faster_checkout(inputs)
	if (locale === "hu") return hu_account_register_benefits_faster_checkout(inputs)
	if (locale === "it") return it_account_register_benefits_faster_checkout(inputs)
	if (locale === "nl") return nl_account_register_benefits_faster_checkout(inputs)
	if (locale === "pl") return pl_account_register_benefits_faster_checkout(inputs)
	if (locale === "pt") return pt_account_register_benefits_faster_checkout(inputs)
	return sv_account_register_benefits_faster_checkout(inputs)
};
export { account_register_benefits_faster_checkout as "account.register_benefits.faster_checkout" }